import React from "react";
import PropTypes from "prop-types";

import {
  List,
  ListHeader,
  ListHeaderItem,
  ListBody,
  ListItemColumn,
} from "@pearsontechnology/aero-components";

import { intl } from "containers/LanguageProvider/IntlGlobalProvider";
import messages from "./messages";
import CohortDeploymentListItem from "./CohortDeploymentListItem";

const sortCohortDeployments = (a, b) =>
  JSON.parse(a.config).title.localeCompare(JSON.parse(b.config).title);

const CohortDeploymentsList = ({
  deployments,
  cohortId,
  updateParentDeploymentState,
  onShowEnrollmentLinks,
  hasEnrollmentLinks,
}) => (
  <List>
    <ListHeader>
      <ListItemColumn colWidth="50%">
        <ListHeaderItem>
          {intl.formatMessage(messages.listColumnHeaderTextTitle)}
        </ListHeaderItem>
      </ListItemColumn>
      <ListItemColumn colWidth="170px" colWidthMobile="60%" grow="0" />
      <ListItemColumn colWidth="170px" colWidthMobile="60%" grow="0" />
      <ListItemColumn colWidth="34px" colWidthMobile="34px" grow="0">
        <div style={{ width: 34 }} />
      </ListItemColumn>
    </ListHeader>
    <ListBody>
      {[...deployments]
        .sort(sortCohortDeployments)
        .map(({ deploymentId, activityId, config, plugin }, index) => {
          const parsedConfig = JSON.parse(config);
          return (
            <CohortDeploymentListItem
              key={`${index}${deploymentId}`}
              deploymentId={deploymentId}
              activityId={activityId}
              parsedConfig={parsedConfig}
              cohortId={cohortId}
              pluginId={plugin.pluginId}
              updateParentDeploymentState={updateParentDeploymentState}
              onShowEnrollmentLinks={onShowEnrollmentLinks}
              hasEnrollmentLinks={hasEnrollmentLinks}
              deploymentListLength={deployments.length}
            />
          );
        })}
    </ListBody>
  </List>
);

CohortDeploymentsList.propTypes = {
  deployments: PropTypes.arrayOf(PropTypes.object),
  cohortId: PropTypes.string,
  updateParentDeploymentState: PropTypes.func,
  onShowEnrollmentLinks: PropTypes.func,
  hasEnrollmentLinks: PropTypes.bool,
};

export default CohortDeploymentsList;
